export default __webpack_public_path__ + "static/media/invisible-eye.26adda44.png";